$(document).ready(function (){

    $(document).on('click', '.datagrid tbody tr td', function (e){
        var href = $(this).parent().find('.row-click');
        if($(this).hasClass('col-action')){
            return;
        }
        if(href.length > 0){
           document.location.href = href.attr('href');
        }
    });

});